import http from "../http-common";

const createAccountLink = (email) => {
    return http.post("/stripe/connect/create-link", {
        email: email,
        refresh_url: window.location.origin + '/stripe/connect/refresh',
        return_url: window.location.origin + '/stripe/connect/return'
    });
};

const getAccountStatus = () => {
    return http.get("/stripe/connect/status");
};

const disconnect = () => {
    return http.post("/stripe/connect/disconnect");
};

const StripeConnectService = {
    createAccountLink,
    getAccountStatus,
    disconnect
};

export default StripeConnectService;